import styles from "./DetailZoneActions.module.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import Icon from "../Icon";
import useFavoriteZone from "../../model/useFavoriteZone";
import { useEffect, useState } from "react";
import { PARK_MACHINE_TYPE } from "../../constants";

type Props = {
    sectionCode: string;
    section: any;
    sectionId: string;
    featureType: "parkingZone" | "parkingMachine";
    properties: any;
    forceReload?: () => void;
    detailZone?: any;
};

const DetailZoneActions = ({ sectionCode, section, sectionId, featureType, properties, forceReload, detailZone }: Props) => {
    const { t } = useTranslation();
    const { zones, add, deleteByIndex } = useFavoriteZone();

    const [isFavorite, setIsFavorite] = useState<boolean>(false);

    useEffect(() => {
        const zone = zones.find(
            (zone) => zone.id === detailZone.properties.sectionID || zone.id === detailZone.properties.parkMachineID
        );
        setIsFavorite(zone);
    }, [zones, detailZone]);

    const handleFavorite = () => {
        if (!isFavorite) {
            add({ id: sectionId, json: JSON.stringify(section) }).then(() => {
                forceReload?.();
            });
        } else {
            deleteByIndex("id", sectionId).then(() => {
                forceReload?.();
            });
        }
    };

    const buyShort = featureType === "parkingZone" ? "pz" : properties.parkMachineType === PARK_MACHINE_TYPE.infobox ? "ib" : "pm";

    return (
        <div className={styles.actions}>
            <button className={`${styles.addToFavorite} ${isFavorite ? styles.active : ""}`} onClick={handleFavorite}>
                <span>
                    <Icon.Star size={18} color={isFavorite ? "#FFFFFF" : "#1D4F8B"} />
                </span>
            </button>

            {section?.tariffInfo?.maxHour > 0 && (
                <Link to={`/buy/${buyShort}/${sectionCode}`} className={`${styles.buyTicket}`}>
                    <Icon.ShoppingBasket size={16} color={"#FFFFFF"} />
                    &nbsp;&nbsp;{t("home.DetailZoneActionsComponent.buy")}
                </Link>
            )}
        </div>
    );
};

export default DetailZoneActions;
